import { render, staticRenderFns } from "./IndicatorsCards.vue?vue&type=template&id=42356f13"
import script from "./IndicatorsCards.vue?vue&type=script&lang=js"
export * from "./IndicatorsCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports